import EmpoweredCommunity from "../images/empowered-community.jpg"
import Evaluation from "../components/Evaluation"
import Greatness from "../components/Greatness"
import JoinCommunity from "../components/JoinCommunityRowV2"
import PowerUpDown from "../components/PowerUpDown"
import Layout from "../components/layout"
import Quote from "../components/Quote"
import React from "react"
import Helmet  from "react-helmet"
import SEO from "../components/seo"
import Button from "../components/Button"
import styles from "../styles/empowered-v2.module.scss"

// Static Home V2 Page
const IndexPage = ({ data }) => (
  <Layout>
    <Helmet>
      <title>The em•powered Community | em•power with Shawna</title>
      <meta name="title" content="The em•powered Community" />
      <meta name="description" content="Learn about the em•powered community and join us on our journey to health and wellness. Let’s be better versions of ourselves by following our ethos manifest!" />   
    </Helmet>

    <section className={styles.intro}>
      <div className={styles.intro_txt}>
        <p className={styles.intro_txt_title}>Welcome to em.power<br/>Your personal sanctuary</p>
        <p>A place to reduce stress and increase well-being, to feel a sense of peace, aliveness & community. A space to awaken and strengthen <span className={styles.highlight}>the power of you.</span></p>
        <div className={styles.intro_txt_btn}>
          <Button
            href={"https://member.empowerofyou.com/log-in/"}
            backgroundColor={"#ffbe76"}
            label={"SIGN IN"}
            fontSize={"18px"}
            target={"_blank"}
            outlineColor={"#ffbe76"}
          />
          <Button
            href={"https://member.empowerofyou.com/checkout/?add-to-cart=4741"}
            backgroundColor={"#ffbe76"}
            label={"GET STARTED"}
            fontSize={"18px"}
            target={"_blank"}
            outlineColor={"#ffbe76"}
          />
        </div>
      </div>
    </section>

    <Evaluation />

    <section className={styles.homeVideo}>
      <div className={styles.homeVideo_video}>
        <iframe src="https://player.vimeo.com/video/453471689" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
      </div>
      <div className={styles.homeVideo_text}>
        <h2 className={styles.homeVideo_text_title}>from my heart</h2>
        <p>It it my passion, purpose and mission to empower you to awaken and harness your natural superpower. A power that is at the very core of who you are. Together we are going to reduce stress and increase well-being, create a personalized roadmap to achieving optimal well-being in every aspect of your life, gain simple mindfulness techniques so you can power down when you need to recharge and I will teach you how to use gratitude as one of your most powerful assets.</p>
        <p>The techniques you will find here in em.power are the same I have used to help my husband regain the ability to walk with the assistant of canes after a life-altering spinal cord injury, as well as become the first athlete with a spinal cord injury push to Antartica’s South Pole. They are the same tools I have developed over the last two decades to help people optimize their health, fitness and create a roadmap for success in all aspects of life.  They are all here for you now. It truly is my heart to serve & give. I look forward to being on this journey together!</p>
      </div>
    </section>

    <section className={styles.joinCommunityRow}>
      <JoinCommunity />
    </section>

    <PowerUpDown />

  </Layout>
)

export default IndexPage

{
  /*
export const query = graphql`
  query {
    allWordpressWpMedia {
      edges {
        node {
          localFile {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`
 */
}
